export default "__VITE_ASSET__CLXy0AtD__"